import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import SEO from "@/components/site/SEO";

export default function Login() {
  const nav = useNavigate();
  const loc = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back${user.name ? ", " + user.name : ""}.`);
      const dest = user.role === "admin" ? "/admin/applications" : (loc.state?.from || "/dashboard");
      nav(dest, { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Login failed.");
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16" data-testid="login-page">
      <SEO title="Sign In" description="Sign in to your Hannah Howard Funding portal to track applications and status." path="/login" />
      <form onSubmit={submit} className="lux-card p-10 sm:p-14 max-w-md w-full">
        <span className="overline">Agent Portal</span>
        <h1 className="font-serif-lux text-4xl mt-3">Welcome Back</h1>
        <p className="text-sm text-[#8C7A70] mt-2">Sign in to view your applications.</p>
        <div className="mt-8 space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-wider">Email</Label>
            <Input type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" required autoComplete="email" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider">Password</Label>
            <Input type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" required autoComplete="current-password" />
          </div>
          <button disabled={submitting} className="btn-primary w-full justify-center mt-2" data-testid="login-submit">
            {submitting ? "Signing in..." : "Sign In"}
          </button>
        </div>
        <p className="text-xs text-[#8C7A70] mt-6 text-center">
          Don't have an account? <Link to="/apply" className="text-[#2A1C14] underline">Apply Now</Link>
        </p>
        <p className="text-xs text-[#8C7A70] mt-2 text-center">
          Trouble logging in? <a href="mailto:hello@hannahhowardfunding.com" className="text-[#2A1C14] underline">Contact us</a>
        </p>
      </form>
    </div>
  );
}
